<!-- 进度条配置 -->
<template>
  <div>
    <el-form-item label="类型">
      <avue-radio v-model="main.activeOption.type"
                  :dic="dicOption.line">
      </avue-radio>
    </el-form-item>
    <el-form-item v-if="main.activeOption.type !== 'circle'" label="进度样式">
      <el-select :value="tech ? 'tech' : 'classic'" aria-label="进度条样式" @input="set('progressStyle', $event)">
        <el-option label="经典样式" value="classic" />
        <el-option label="圆角渐变" value="tech" />
      </el-select>
    </el-form-item>
    <template v-if="tech">
      <el-form-item label="进度条高度"><el-input-number :value="settings.height" label="进度条高度" :min="2" :max="80" controls-position="right" @change="set('progressHeight', $event)" /></el-form-item>
      <el-form-item label="百分比字号"><el-input-number :value="settings.fontSize" label="进度条百分比字号" :min="8" :max="100" controls-position="right" @change="set('progressFontSize', $event)" /></el-form-item>
      <el-form-item label="百分比间距"><el-input-number :value="settings.gap" label="进度条百分比间距" :min="0" :max="100" controls-position="right" @change="set('progressGap', $event)" /></el-form-item>
      <el-form-item label="小数位数"><el-input-number :value="settings.precision" label="进度条百分比小数位数" :min="0" :max="6" :precision="0" controls-position="right" @change="set('progressPrecision', $event)" /></el-form-item>
      <el-form-item v-for="field in colors" :key="field.key" :label="field.label">
        <div class="progress-color-field"><el-input :value="colorInput(field)" :label="'进度条' + field.label" placeholder="#13cfff 或 rgba(...)" @input="set(field.key, $event)" /><el-color-picker :value="settings[field.name]" show-alpha @change="set(field.key, $event || '')" /></div>
      </el-form-item>
      <p class="progress-settings-help">仅显示进度条和右侧百分比，可搭配文字组件。百分比取数据配置中的 data 字段（0～100），例如 {"data":68.9}。</p>
    </template>
    <template v-else>
    <el-form-item label="间距">
      <avue-input-number v-model="main.activeOption.split"
                         :max="200"></avue-input-number>
    </el-form-item>
    <el-form-item label="边框颜色">
      <avue-input-color v-model="main.activeOption.borderColor"></avue-input-color>
    </el-form-item>
    <el-form-item label="边框大小">
      <avue-input-number v-model="main.activeOption.strokeWidth"
                         :max="50"></avue-input-number>
    </el-form-item>
    <el-form-item label="字体大小">
      <avue-input-number v-model="main.activeOption.fontSize"
                         :max="200"></avue-input-number>
    </el-form-item>
    <el-form-item label="文字字体">
      <avue-select v-model="main.activeOption.fontFamily"
                   :dic="dicOption.fontFamily">
      </avue-select>
    </el-form-item>
    <el-form-item label="字体颜色">
      <avue-input-color v-model="main.activeOption.color"></avue-input-color>
    </el-form-item>
    <el-form-item label="文字粗细">
      <avue-select v-model="main.activeOption.FontWeight"
                   :dic="dicOption.fontWeight">
      </avue-select>
    </el-form-item>
    <el-form-item label="前缀字体大小">
      <avue-input-number v-model="main.activeOption.suffixFontSize"
                         :max="200"></avue-input-number>
    </el-form-item>
    <el-form-item label="前缀文字字体">
      <avue-select v-model="main.activeOption.suffixFontFamily"
                   :dic="dicOption.fontFamily">
      </avue-select>
    </el-form-item>
    <el-form-item label="前缀字体颜色">
      <avue-input-color v-model="main.activeOption.suffixColor"></avue-input-color>
    </el-form-item>
    <el-form-item label="前缀文字粗细">
      <avue-select v-model="main.activeOption.suffixFontWeight"
                   :dic="dicOption.fontWeight">
      </avue-select>
    </el-form-item>
    </template>
  </div>
</template>

<script>
import { dicOption } from '@/option/config'
import { progressPresentationSettings } from '@/runtime/progress-presentation'
export default {
  data () {
    return {
      dicOption: dicOption,
      colors: [{ key: 'progressStartColor', name: 'startColor', label: '渐变起始色' }, { key: 'progressEndColor', name: 'endColor', label: '渐变结束色' }, { key: 'progressTrackColor', name: 'trackColor', label: '轨道颜色' }, { key: 'progressTextColor', name: 'textColor', label: '百分比颜色' }]
    }
  },
  inject: ["main"],
  computed: {
    tech () { return this.main.activeOption.type !== 'circle' && this.main.activeOption.progressStyle === 'tech' },
    settings () { return progressPresentationSettings(this.main.activeOption) }
  },
  methods: {
    colorInput (field) { const value = this.main.activeOption[field.key]; return typeof value === 'string' ? value : this.settings[field.name] },
    set (key, value) { if (!this.main.activeLayoutLocked) this.$set(this.main.activeOption, key, value) }
  }
}
</script>

<style scoped>
.el-select, .el-input-number { width: 100%; }
.progress-color-field { display: flex; align-items: center; gap: 6px; min-width: 0; }
.progress-color-field .el-input { flex: 1; min-width: 0; }
.progress-color-field .el-color-picker { flex: none; }
.progress-settings-help { color: #a4b6c5; font-size: 12px; line-height: 1.6; margin: 0 0 12px; }
</style>
